<template>
  <div>
    <div class="window work-display" :style="windowWidth >= 1280 ? {top: 25 + work.id * 25 + 'px', left: (windowWidth - 720) / 2 + work.id * 25 + 'px'} : {}" :class="{'above': work.hasFocus}" @mousedown="getFocus()">
      <div class="window-title-bar">
        {{ work.title }}
        <div class="window-title-bar-button" @click="closeWindow()">X</div>
      </div>
      <div class="window-main">
        <iframe :src="work.link" class="window-content navigator" v-if="work.link"></iframe>
        <img class="window-content window-image" :src="work.image" :style="{backgroundColor: work.bgColor}" alt="work.title" v-if="work.image">
        <div class="window-text" v-if="work.content">
          <Contact v-if="work.content === 'contact'" />
        </div>
        <div class="window warning-prompt" v-show="work.id === 1 && show">
          <div class="window-title-bar">
            Warning
            <div class="window-title-bar-button" @click="closeWindow()">X</div>
          </div>
          <div class="window-main">
            <span class="warning-text">どこまで逃げるの？</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '../misc/Contact.vue'

export default {
  props: {
    work: {
      type: Object,
      required: true
    }
  },
  components: {
    Contact: Contact
  },
  data () {
    return {
      show: false,
      currTarget: null,
      offset: {
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    windowWidth () {
      return window.innerWidth
    }
  },
  methods: {
    showError () {
      setTimeout(() => {
        this.show = true
      }, 500)
    },
    getFocus () {
      this.$emit('getFocus', this.work.id)
    },
    moveWindow (e) {
      const clientX = e.clientX
      const clientY = e.clientY

      this.currTarget.parentElement.style.transform = "translateX(0) translateY(0)"
      this.currTarget.parentElement.style.top = clientY - this.offset.y + 'px'
      this.currTarget.parentElement.style.left = clientX - this.offset.x + 'px'
    },
    closeWindow () {
      this.$emit('closeWindow', this.work.id)
    }
  },
  mounted () {
    if (this.work.id === 1) {
      this.showError()
    } else {
      this.show = false
    }

    if (this.windowWidth >= 1280) {
      document.querySelectorAll('.window-title-bar').forEach((windowBar) => {
        windowBar.addEventListener('mousedown', (e) => {
          this.currTarget = e.target
          this.offset.x = e.offsetX
          this.offset.y = e.offsetY

          document.querySelector('#sad-windows').addEventListener('mousemove', this.moveWindow)
        })

        windowBar.addEventListener('mouseup', () => {
          document.querySelector('#sad-windows').removeEventListener('mousemove', this.moveWindow)
        })
      })
    }
  },
  updated () {
    this.showError()
  }
}
</script>

<style>
.above {
  z-index: 1001;
}

.window {
  display: inline-block;
  border: 2px outset #DDD;
  box-shadow: 2px 2px 2px #444;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.work-display {
  position: absolute;
}

.window-title-bar {
  position: relative;
  display: block;
  padding: 8px;
  background-color: #12D;
  color: #FFF;
  font-weight: bold;
}

.window-title-bar-button {
  position: absolute;
  top: 4px;
  right: 4px;
  display: block;
  border: 2px outset #DDD;
  background-color: #DDD;
  color: #222;
  text-shadow: 1px 1px #EEE;
  font-size: 20px;
  font-weight: 200;
  text-align: center;
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.window-main {
  background-color: #DDD;
}

.window-content {
  display: block;
  border: 2px inset #DDD;
}

.window-image {
  max-width: calc(100vw - 58px);
  max-height: calc(100vh - 217px);
}

.navigator {
  width: calc(100vw - 58px);
  max-width: 600px;
  height: calc(100vh - 217px);
  max-height: 600px;
}

.window-text {
  padding: 10px;
  text-shadow: 1px 1px #EEE;
}

.warning-prompt {
  position: absolute;
  top: 38%;
  left: 29%;
  width: 50%;
  background-color: #DDD;
}

.warning-prompt .window-main {
  height: 100%;
}

.warning-text {
  display: block;
  margin: 20px;
  text-align: center;
  text-shadow: 1px 1px #EEE;
}

.warning-text:before {
  position: absolute;
  top: 48px;
  left: 28px;
  display: block;
  content: 'X';
  width: 32px;
  height: 32px;
  border: 1px solid #800;
  border-radius: 16px;
  box-shadow: 2px 2px #888;
  background-color: #F00;
  color: #FFF;
  font-weight: bold;
  font-size: 29px;
}

@media (max-width: 1280px) {
  .work-display {
    top: 50vh;
    left: 50vw;
    transform: translateX(-50%) translateY(-50%);
  }
}

@media (max-width: 628px), (max-height: 780px) {
  .warning-text:before {
    display: none;
  }
}

@media (max-width: 480px), (max-height: 640px) {
  .warning-prompt .window-title-bar {
    display: none;
  }

  .warning-prompt {
    top: 40%;
  }
}

@media (max-width: 422px), (max-height: 552px) {
  .warning-text {
    margin: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/window/Window.vue